import {
    Box,
    FormControl,
    FormControlLabel,
    SelectChangeEvent,
    Grid,
    Select
  } from "@mui/material";
  import React, { useState } from "react";
  import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
  import styles from "./priestScheduleReport.module.scss";
  import stylesWeek from '../reportSection.module.scss'
  import { styled } from "@mui/material/styles";
  import { apiRequest } from "../../../infrastructure/backendService";
  import {CustomInputLabel, CustomRadioButton, CommonButton, CustomMenuItem, StyledDateContainer, CustomCalendarTodayOutlinedIcon, CustomDatePicker, CommonOutlinedButton, formatAmount } from "../../common/StyledComponents/StyledFields";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";
import { ClipLoader } from "react-spinners";
import CustomSelectField from "../../CompactCustomComponents/CustomSelectField";

const CustomSelect = styled(Select)`
& svg {
    color: #F05802;
 }
 & div {
    overflow: unset;
    padding: 14px 16px;
    height: 20px !important;
    min-height: 0px !important;
    border-radius: 8px;
    background: #fff;
    min-width: 0 !important;
 }
 & input {
    padding: 14px 16px;
    height: 20px;
    border-radius: 8px;
 }
 & fieldset {
    border-style: unset;
 }
`;
  const stylesDropdown = {
    textField: {
      border: "1px solid rgba(136, 46, 20, 0.4)",
      backgroundColor: "#FFF9E4",
      borderRadius: "8px",
    },
    errorTextField: {
      border: "1px solid #f05802",
      borderRadius: "8px",
      width: "100%",
      backgroundColor: "#FFF9E4",
    },
  };
  const RevenueSummaryReport = ({ sendDataToParent, getReportData }:any) => {
    const currentDate = new Date();
     const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];    
    const quaterlyYearsList = ["Jan-Mar", "Apr-Jun", "Jul-Sep", "Oct-Dec"]; 
    // var currentMonthNumber = currentDate.toLocaleDateString('en-US', { month: 'short' }).toUpperCase();
    var currentMonthNumber = currentDate.getMonth();
    const [selectedYear, setSelectedYear] = useState<any>(
      currentDate.getFullYear()
    );
    const [searchButton, setSearchButton] = useState<boolean>(true);
    const [selectedMonthID, setSelectedMonthID] = useState<any>(
      currentMonthNumber
    );
    const [selectedWeek, setSelectedWeek] = useState<string>(dayjs().format("MM/DD/YYYY"));
    const [showWeekly, setShowWeekly] = useState<boolean>(false);
    const [selectedQuater, setSelectedQuater] = useState<any>("");
    const [showMonthly, setShowMonthly] = useState<boolean>(false);
    const [showQuaterly, setShowQuaterly] = useState<boolean>(false);
    const [showYearly, setShowYearly] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
  
    const Years = [
      {
        year: 2023,
      },
      {
        year: 2024,
      },
    ];
  
    const apiCall = () => {
        let reqBody:any = {};
        let selectYear:number;
        let selectMonth:any;
        let selectQuarter:any;
        if(showWeekly) {
            reqBody.searchStartDate = selectedWeek;
            reqBody.searchEndDate = dayjs(selectedWeek, "MM/DD/YYYY").add(1, 'week').format("MM/DD/YYYY");
            reqBody.weeklySearch = true;
        } else if(showMonthly) {
          let monthStartDate = dayjs(new Date(selectedYear, selectedMonthID)).format("MM/DD/YYYY");
          let monthEndDate = dayjs(new Date(selectedYear, selectedMonthID+1, 0)).format("MM/DD/YYYY");
            reqBody.searchStartDate = monthStartDate;
            reqBody.searchEndDate = monthEndDate;
            reqBody.monthlySearch = true;
            selectMonth = months[selectedMonthID]
            selectYear = selectedYear
        } else if(showQuaterly) {
            let quarterStartDate = dayjs(new Date(selectedYear, selectedQuater)).format("MM/DD/YYYY");
            let quarterEndDate = dayjs(new Date(selectedYear, selectedQuater+3, 0)).format("MM/DD/YYYY");
            reqBody.searchStartDate = quarterStartDate;
            reqBody.searchEndDate = quarterEndDate;
            reqBody.quarterlySearch = true;
            selectQuarter = quaterlyYearsList[selectedQuater]
            selectYear = selectedYear
        } else if(showYearly) {
            reqBody.searchStartDate = dayjs(new Date(selectedYear, 0, 1)).format("MM/DD/YYYY");
            reqBody.searchEndDate = dayjs(new Date(selectedYear, 11, 31)).format("MM/DD/YYYY");
            reqBody.yearlySearch = true;
        }
        setLoading(true);
      apiRequest({
        method: "POST",
        endpoint: '/report-dashboard/reports/treasury/REVENUE_SUMMARY_REPORT/browser',
        body: JSON.stringify(reqBody),
        includeToken: true,
      })
        .then((res: any) => {
          setLoading(false);
          setSearchButton(true);
          sendDataToParent(true,{reqBody,dateObj:{
            selectYear,
            selectMonth,
            selectQuarter,}});
          const response = res.data[0].data.map((report:any)=>{
            return {
              "Name (Sign-in)": report.username,
              "Pooja Booking": formatAmount(report.poojaBookingAmount),
              "Donation": formatAmount(report.donationAmount),
              "Hall Rental": formatAmount(report.hallRentalAmount),
              "Prasadam": formatAmount(report.prasadamAmount),
              "Calendar": formatAmount(report.calendarAmount),
              "Others": formatAmount(report.othersAmount),
            };
          })
          getReportData(response);
        })
        .catch((err: any) => {
          setLoading(false);
          console.log(err);
        });
    };
  
    const handlesubmit = () => {
      apiCall();
    };

    const handleClear = () => { 
      setSelectedWeek(" ");
      setSelectedMonthID("");
      setSelectedQuater("");
      setSelectedYear("");

    }   

    const DatePickerWeekly = (): React.ReactElement => {
        return (
            <div className={styles.dateconatiner}>
                <StyledDateContainer className={stylesWeek.styledConatiner}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <CustomDatePicker
                                slots={{
                                    openPickerIcon: CustomCalendarTodayOutlinedIcon,
                                }}
                                slotProps={{
                                    inputAdornment: {
                                        position: 'end',
                                    },
                                }}
                                format="MM-DD-YYYY"
                                value={
                                    selectedWeek ? dayjs(selectedWeek, 'MM-DD-YYYY') : ''
                                }
                                onChange={(value) => {
                                    handleWeekChange(value);
                                }}
                                disableFuture
                                // className={stylesWeek.dateFeildforfamily}
                                className={'text_field bg_white compact_fields'}
                            />
                        </DemoContainer>
                    </LocalizationProvider>

                </StyledDateContainer>
            </div>
        );
    };
  
    const quaterlyYearsDropdown = () => {
      return (
        <FormControl className={styles.dropdown}>
          <CustomSelect
            IconComponent={KeyboardArrowDownIcon}
            id="grouped-select"
            onChange={handlequaterlyChange}
            value={selectedQuater}
            placeholder="Please Select"
            MenuProps={{
              PaperProps: {
                 sx: {
                    border: '1px solid #F05802',
                    '& ul': {
                       paddingTop: 0,
                       paddingBottom: 0,
                       overflowY: 'auto',
                       minHeight: 'auto',
                       maxHeight: '300px',
                       '&::-webkit-scrollbar': {
                          width: '8px',
                       },
                       '&::-webkit-scrollbar-thumb': {
                          background: '#F3C539',
                          borderRadius: '6px',
                       },
                    },
                 },
              },
           }}
           sx={[{...stylesDropdown.textField,backgroundColor:'#fff'},
            {
              "& .MuiSelect-outlined": {
                opacity: 1,
                p: "8px",
                fontSize: "14px",
                fontFamily: "Lato",
                backgroundColor:'#fff'
              },
            },
          ]}
          >
            {quaterlyYearsList.map((quarter: any, index: any) => (
                <CustomMenuItem value={index*3} key={index}>
                    {quarter}
                </CustomMenuItem>
            ))}
          </CustomSelect>
        </FormControl>
      );
    };

    const handlequaterlyChange = (event: any) => {
        setSelectedQuater(event.target.value);
        setSearchButton(false);
      };
    const handleYearChange = (field="", value: any) => {
      setSelectedYear(value as number);
      setSearchButton(false);
    };
const handleMonthChange = (event: SelectChangeEvent<unknown>) => {
      setSelectedMonthID(event.target.value as number);
      setSearchButton(false);
    };
    const handleWeekChange = (value: any) => {
        const selectedWeek = dayjs(value, "MM/DD/YYYY").format("MM/DD/YYYY");
        setSelectedWeek(selectedWeek);
        setSearchButton(false);
    }
    const YearsDropdown = (): React.ReactElement => {
      return (
        <CustomSelectField
          id="grouped-select"
          handleDropdownChange={handleYearChange}
          errorMessage={""}
          dropDownList={Years}
          value={selectedYear}
          fieldName="selectedYear"
          placeholder={""}
          optionLabel="year"
          optionValue="year"
          overrideStyles={{ backgroundColor: "white" }}
        />
      );
    };
     const MonthsDropdown = (): React.ReactElement => {
      return (
        <FormControl className={styles.dropdown}>
          <CustomSelect
            IconComponent={KeyboardArrowDownIcon}
            id="grouped-select"
            onChange={handleMonthChange}
            value={selectedMonthID}
            MenuProps={{
              PaperProps: {
                 sx: {
                    border: '1px solid #F05802',
                    '& ul': {
                       paddingTop: 0,
                       paddingBottom: 0,
                       overflowY: 'auto',
                       minHeight: 'auto',
                       maxHeight: '300px',
                       '&::-webkit-scrollbar': {
                          width: '8px',
                       },
                       '&::-webkit-scrollbar-thumb': {
                          background: '#F3C539',
                          borderRadius: '6px',
                       },
                    },
                 },
              },
           }}
           sx={[
            {...stylesDropdown.textField, backgroundColor:'#fff'},
            {
              "& .MuiSelect-outlined": {
                opacity: 1,
                p: "8px",
                fontSize: "14px",
                fontFamily: "Lato",
                backgroundColor:'#fff'
              },
            },
          ]}
          >
            {months.map((month: any, index: any) => (
                <CustomMenuItem value={index} key={index}>
                    {month}
                </CustomMenuItem>
            ))}
          </CustomSelect>
        </FormControl>
      );
    };
    const weeklyComponent = () => {
        return (
                <Grid container spacing={2} sx={{ mt: 0 }}>
                    <Grid item xs={12} sm={3}>
                        <CustomInputLabel>Weekly</CustomInputLabel>
                        {DatePickerWeekly()}
                    </Grid>
                </Grid>
        );
    };

    const monthlyComponent = () => {
      return (
        <Grid container spacing={2} className={styles.dropdownConatiner}>
          <Grid xs={12} sm={3} item>
            <CustomInputLabel>Month</CustomInputLabel>
            {MonthsDropdown()}
          </Grid>
          <Grid xs={12} sm={3} item>
            <CustomInputLabel>Year</CustomInputLabel>
            {YearsDropdown()}
          </Grid>
        </Grid>
      );
    };
  
    const quaterlyComponent = () => {
      return (
        <Grid container spacing={2} className={styles.dropdownConatiner}>
          <Grid xs={12} sm={3} item>
            <CustomInputLabel>Search By Quarterly</CustomInputLabel>
            {quaterlyYearsDropdown()}
          </Grid>
          <Grid xs={12} sm={3} item>
            <CustomInputLabel>Year</CustomInputLabel>
            {YearsDropdown()}
          </Grid>
        </Grid>
      );
    };
  
    const yearlyComponent = () => {
      return (
        <Grid container spacing={2} sx={{ width: "100%" }} className={styles.dropdownConatiner}>
          <Grid xs={12} sm={3} item>
            <CustomInputLabel>Search By Yearly</CustomInputLabel>
            {YearsDropdown()}
          </Grid>
        </Grid>
      );
    };
  
    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const selectedValue = event.target.value;
  
      // Update state based on the selected radio button
      switch (selectedValue) {
        case "Weekly":
            setShowWeekly(true);
          setShowMonthly(false);
          setShowQuaterly(false);
          setShowYearly(false);
          setSelectedMonthID(currentMonthNumber);
          break;
        case "Monthly":
            setShowWeekly(false);
          setShowMonthly(true);
          setShowQuaterly(false);
          setShowYearly(false);
          setSelectedYear(currentDate.getFullYear());
          setSelectedQuater("");
          setSelectedMonthID(currentMonthNumber);
          break;
        case "Search By Quarterly":
            setShowWeekly(false);
          setShowMonthly(false);
          setShowQuaterly(true);
          setShowYearly(false);
          setSelectedYear(currentDate.getFullYear());
          setSelectedMonthID(currentMonthNumber);
          break;
        case "Search By Yearly":
            setShowWeekly(false);
          setShowMonthly(false);
          setShowQuaterly(false);
          setShowYearly(true);
          setSelectedQuater("");
          setSelectedYear(currentDate.getFullYear());
          setSelectedMonthID(currentMonthNumber);
          break;
        default:
          setShowMonthly(false);
          setShowQuaterly(false);
          setShowYearly(false);
          setSelectedQuater("");
          setSelectedYear(currentDate.getFullYear());
          setSelectedMonthID(currentMonthNumber);
      }
      setSearchButton(false);
    };
  
    const radioButtonsComponent = () => {
      return (
        <Box sx={{ marginBottom: "16px", display: "flex", flexDirection: "row" }}>
          <FormControlLabel
            value="Weekly"
            control={
                <CustomRadioButton 
                    checked={showWeekly}
                    onChange={handleRadioChange}
                />
            }
            label="Weekly"
          />
          <FormControlLabel
            value="Monthly"
            control={
              <CustomRadioButton
                checked={showMonthly}
                onChange={handleRadioChange}
              />
            }
            label="Monthly"
          />
          <FormControlLabel
            value="Search By Quarterly"
            control={
              <CustomRadioButton
                checked={showQuaterly}
                onChange={handleRadioChange}
              />
            }
            label="Search By Quarterly"
          />
          {/* <FormControlLabel
            value="Search By Yearly"
            control={
              <CustomRadioButton
                checked={showYearly}
                onChange={handleRadioChange}
              />
            }
            label="Search By Yearly"
          /> */}
        </Box>
      );
    };
    const renderComponent = () => {
      return (
        <>
          {showWeekly ? weeklyComponent() : ""}
          {showMonthly ? monthlyComponent() : ""}
          {showQuaterly ? quaterlyComponent() : ""}
          {showYearly ? yearlyComponent() : ""}
        </>
      );
    };
    
    return (
      <div>
        {radioButtonsComponent()}
        {renderComponent()}
        <Box sx={{ display: "flex", alignItems: "center", my: "20px",gap:"16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlesubmit}
          disabled={searchButton || loading}
          id="submit"
        >
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Submitting...
              </span>
            </>
          ) : (
            "Submit"
          )}
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
        </Box>
      </div>
    );
  };
  
  export default RevenueSummaryReport;
  